import { render, staticRenderFns } from "./HrSalaryLaborFee.vue?vue&type=template&id=3faebee5&scoped=true&"
import script from "./HrSalaryLaborFee.vue?vue&type=script&lang=js&"
export * from "./HrSalaryLaborFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faebee5",
  null
  
)

export default component.exports